import { useEffect, useRef, useState } from 'react';
import PieChartWidget from './PieChartWidget';
import { RegistrationsTable } from './RegistrationsTable';
import { ApiClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import Loader from '@/app/components/loader';

export default function RegistrationTab({ filters, currentFilters, institutions }) {
  const [pieChartData, setPieChartData] = useState([]);
  const [loadingGraph, setLoadingGraph] = useState(false);
  const apiSso = process.env.REACT_APP_SSO_API_URL;

  const client = new ApiClient({
    url: `${apiSso}/api/v1`
  });

  const getGraphData = async () => {
    setLoadingGraph(true);
    try {
      const { data } = await client.fetch('/institution_infos/graphs');
      setPieChartData(data.gres);
    } catch (error) {
      toast.error('Erro ao buscar os dados do gráfico.');
    }
    setLoadingGraph(false);
  };

  useEffect(() => {
    getGraphData();
  }, []);

  return (
    <>
      {loadingGraph && <Loader />}
      {!loadingGraph && (
        <>
          <PieChartWidget
            data={pieChartData}
            filters={currentFilters}
            institutions={institutions}
          />
          <RegistrationsTable
            filters={filters}
            currentFilters={currentFilters}
          />
        </>
      )}
    </>
  );
}
